import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';

import { SwitchCasesTypeChanged } from '../../../../../services/dto/switch-cases';
import { SwitchCaseBaseComponent } from '../switch-case-base/switch-case-base.component';

@Component({
  selector: 'cam-switch-cases-type-changed',
  templateUrl: './switch-cases-type-changed.component.html',
  styleUrls: ['./switch-cases-type-changed.component.scss'],
  imports: [TranslatePipe],
})
export class SwitchCasesTypeChangedComponent extends SwitchCaseBaseComponent<SwitchCasesTypeChanged> {}
